import { formatDate, formatDateTime } from '@blimo/shared';

/**
 * Admin routes per audit subject type (morph alias). Only types with a detail page are linked.
 * @type {Record<string, (subject: any) => { to: string, params: Record<string, string> } | null>}
 */
const SUBJECT_ROUTES = {
  property: (s) => ({ to: '/liegenschaften/$propertyId', params: { propertyId: String(s.id) } }),
  unit: (s) => ({ to: '/einheiten/$unitId', params: { unitId: String(s.id) } }),
  party: (s) => ({ to: '/personen/$partyId', params: { partyId: String(s.id) } }),
  user: (s) => ({ to: '/administration/benutzer/$userId', params: { userId: String(s.id) } }),
  document_check: (s) => ({ to: '/belegpruefung/$checkId', params: { checkId: String(s.id) } }),
  announcement: (s) => ({ to: '/kommunikation/mitteilungen/$announcementId', params: { announcementId: String(s.id) } }),
  message_thread: (s) => ({ to: '/kommunikation/posteingang/$threadId', params: { threadId: String(s.id) } }),
  outbound_message: (s) => ({ to: '/kommunikation/versandhistorie/$messageId', params: { messageId: String(s.id) } }),
  meter: (s) => ({ to: '/zaehler/$meterId', params: { meterId: String(s.id) } }),
  meter_reading: (s) => (s.parent_id ? { to: '/zaehler/$meterId', params: { meterId: String(s.parent_id) } } : null),
};

/** @param {any} subject */
export function subjectRoute(subject) {
  if (!subject?.exists) return null;
  return SUBJECT_ROUTES[subject.type]?.(subject) ?? null;
}

const ISO_DATE = /^\d{4}-\d{2}-\d{2}$/;
const ISO_DATETIME = /^\d{4}-\d{2}-\d{2}[T ]\d{2}:\d{2}/;

/** Readable rendering of an old/new value (presentation only). @param {unknown} value @returns {string} */
export function formatAuditValue(value) {
  if (value === null || value === undefined || value === '') return '–';
  if (typeof value === 'boolean') return value ? 'Ja' : 'Nein';
  if (Array.isArray(value)) return value.length ? value.map(formatAuditValue).join(', ') : '–';
  if (typeof value === 'object') return JSON.stringify(value);
  if (typeof value === 'string' && ISO_DATE.test(value)) return formatDate(value);
  if (typeof value === 'string' && ISO_DATETIME.test(value)) return formatDateTime(value);
  return String(value);
}
